import React, { useCallback, useEffect, useState } from "react";
import
  {
    startOfToday,
    endOfToday,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfYear,
    endOfYear,
  } from "date-fns";

import { Link, withRouter } from "react-router-dom";
import
  {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    FormGroup,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Pagination,
    PaginationItem,
    PaginationLink,
    Progress,
    Row,
    TabContent,
    Table,
    TabPane,
    UncontrolledCollapse,
    UncontrolledDropdown,
    UncontrolledTooltip,
  } from "reactstrap";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import light from "../../../assets/images/logo-light.png";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../../assets/images/users/avatar-8.jpg";

import smallImage2 from "../../../assets/images/small/img-2.jpg";
import smallImage3 from "../../../assets/images/small/img-3.jpg";
import smallImage4 from "../../../assets/images/small/img-4.jpg";
import smallImage5 from "../../../assets/images/small/img-5.jpg";
import smallImage6 from "../../../assets/images/small/img-6.jpg";
import smallImage7 from "../../../assets/images/small/img-7.jpg";
import smallImage9 from "../../../assets/images/small/img-9.jpg";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

const HistoriqueCourses = ( props ) =>
{
  SwiperCore.use( [ Autoplay ] );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  function statutColor ( statut )
  {
    let color;
    switch ( statut.toLowerCase() )
    {
      case "en attente":
        color = "warning";
        break;
      case "accepter":
        color = "info";
        break;
      case "pret":
        color = "primary";
        break;
      case "commencer":
        color = "success";
        break;
      case "terminer":
        color = "success";
        break;
      case "annuler":
        color = "danger";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }
  function convertDate ( date )
  {
    return new Date( date );
  }

  const [ activityTab, setActivityTab ] = useState( "3" );
  const toggleActivityTab = ( tab ) =>
  {
    if ( activityTab !== tab )
    {
      setActivityTab( tab );
    }
  };

  const [ coursesList, setCoursesList ] = useState( [] );
  const [ optionFilter, setOptionFilter ] = useState( [] );
  const [ optionFilterValue, setOptionFilterValue ] = useState( "" );
  const fetchCourseList = async () =>
  {
    try
    {
      const course_list = await axiosInstance.get( `/coursedetail` );

      setCoursesList(
        course_list.data.data
          .filter( ( course ) => course.course_status !== "En attente" )
          .sort( ( a, b ) => new Date( b.date_course ) - new Date( a.date_course ) )
      );
      // console.log(course_list);
      // console.log("Course List: ", course_list.data.data);
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };

  useEffect( () =>
  {
    try
    {
      fetchCourseList();
    } catch ( error )
    {
      console.error( "Erreur de fetch course: ", error );
    }
    // finally {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 2000);
    // }
  }, [] );

  const [ loading, setLoading ] = useState( true );
  const [ coursesPeriod, setCoursesPeriod ] = useState( "" );
  const [ coursesPeriodList, setCoursesPeriodList ] = useState( [] );
  const [ searchTerm, setSearchTerm ] = useState( "" );

  const onChangeCoursesPeriod = useCallback(
    ( period = "" ) =>
    {
      // console.log("coursesList: ", coursesList);

      let datedebut, datefin;
      let listFiltered = [];

      switch ( period )
      {
        case "aujourd'hui":
          setCoursesPeriod( "aujourd'hui" );
          datedebut = startOfToday();
          datefin = endOfToday();
          break;
        case "semaine":
          setCoursesPeriod( "semaine" );
          datedebut = startOfWeek( new Date(), { weekStartsOn: 1 } ); // Assuming the week starts on Monday
          datefin = endOfWeek( new Date(), { weekStartsOn: 1 } );
          break;
        case "mois":
          setCoursesPeriod( "mois" );
          datedebut = startOfMonth( new Date() );
          datefin = endOfMonth( new Date() );
          break;
        case "an":
          setCoursesPeriod( "an" );
          datedebut = startOfYear( new Date() );
          datefin = endOfYear( new Date() );
          break;
        default:
          setCoursesPeriod( "" );
          datedebut = null;
          datefin = null;
          break;
      }

      if ( datedebut && datefin )
      {
        const dateDebut = new Date( datedebut );
        const dateFin = new Date( datefin );

        listFiltered = coursesList
          .filter(
            ( course ) =>
              new Date( course.date_course ) >= dateDebut &&
              new Date( course.date_course ) <= dateFin
          )
          .sort( ( a, b ) => new Date( b.date_course ) - new Date( a.date_course ) );
      } else
      {
        listFiltered = coursesList;
      }

      setCoursesPeriodList( listFiltered );
      // setLoading(false);

      return listFiltered;
    },
    [ coursesList ]
  );

  useEffect( () =>
  {
    onChangeCoursesPeriod( coursesPeriod );
  }, [ coursesList, coursesPeriod, onChangeCoursesPeriod ] );

  // Recherche && recherche
  useEffect( () =>
  {
    let list = onChangeCoursesPeriod( coursesPeriod );
    console.log( "list: ", list );

    const listFiltered =
      list &&
      list
        .filter(
          ( course ) =>
            ( course.immatriculation &&
              course.immatriculation
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.adresse_depart &&
              course.adresse_depart
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.adresse_destination &&
              course.adresse_destination
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.engin_designation &&
              course.engin_designation
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.engin_classe &&
              course.engin_classe
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.last_name_client &&
              course.last_name_client
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.first_name_client &&
              course.first_name_client
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.first_name_client &&
              course.first_name_client
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.first_name_conducteur &&
              course.first_name_conducteur
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) ) ||
            ( course.date_course &&
              course.date_course
                .toLowerCase()
                .includes( searchTerm.toLowerCase() ) )
        )
        .sort( ( a, b ) => new Date( b.date_course ) - new Date( a.date_course ) );
    // setCoursesPeriodList(listFiltered);

    const listFilteredStatus =
      optionFilterValue !== ""
        ? listFiltered &&
        listFiltered.filter(
          ( course ) =>
            course.course_status && course.course_status === optionFilterValue
        )
        : listFiltered;

    setCoursesPeriodList( listFilteredStatus );
  }, [ optionFilterValue, searchTerm, coursesPeriod, onChangeCoursesPeriod ] );

  function getUniqueStatuses ( courses )
  {
    const statuses = courses.map( ( course ) => course.course_status );
    return [ ...new Set( statuses ) ]; // Supprime les doublons
  }

  useEffect( () =>
  {
    const status = getUniqueStatuses( coursesList );
    // console.log("status: ", status);
    setOptionFilter( status );
  }, [ coursesList ] );

  document.title = "Historique des courses | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Courses" ) } pageTitle="Takci" />

          <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
              <img src={ profileBg } alt="" className="profile-wid-img" />
            </div>
          </div>

          <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
            <Row className="g-4" style={ { justifyContent: "center" } }>
              <div className="col-auto">
                <div
                  className="avatar-lg"
                  style={ {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  } }
                >
                  <img src={ light } alt="user-img" width="100px" />
                </div>
              </div>
            </Row>
          </div>

          <div>
            <Row>
              <Col xxl={ 12 }>
                <Row>
                  <Col lg={ 12 }>
                    <Card>
                      <CardHeader className="align-items-center">
                        <div className="d-flex align-items-center">
                          <h4 className="card-title mb-0  me-2">
                            Courses { coursesPeriod }{ " " }
                            { coursesPeriodList &&
                              `(${ coursesPeriodList.length })` }
                          </h4>

                          <div className="flex-shrink-0 ms-auto">
                            <div className="justify-content-end d-none d-md-flex gap-1">
                              <button
                                disabled={ coursesPeriod === "" }
                                className="btn"
                                style={ {
                                  background: "#002437",
                                  color: "white",
                                } }
                                onClick={ ( e ) =>
                                {
                                  e.preventDefault();
                                  onChangeCoursesPeriod( "tous" );
                                } }
                              >
                                { props.t( "Tous" ) }
                              </button>

                              <button
                                disabled={ coursesPeriod === "aujourd'hui" }
                                className="btn"
                                style={ {
                                  background: "#002437",
                                  color: "white",
                                } }
                                onClick={ ( e ) =>
                                {
                                  e.preventDefault();
                                  onChangeCoursesPeriod( "aujourd'hui" );
                                } }
                              >
                                { props.t( "Today" ) }
                              </button>

                              <button
                                disabled={ coursesPeriod === "semaine" }
                                className="btn"
                                style={ {
                                  background: "#002437",
                                  color: "white",
                                } }
                                onClick={ ( e ) =>
                                {
                                  e.preventDefault();
                                  onChangeCoursesPeriod( "semaine" );
                                } }
                              >
                                { props.t( "Week" ) }
                              </button>

                              <button
                                disabled={ coursesPeriod === "mois" }
                                className="btn"
                                style={ {
                                  background: "#002437",
                                  color: "white",
                                } }
                                onClick={ ( e ) =>
                                {
                                  e.preventDefault();
                                  onChangeCoursesPeriod( "mois" );
                                } }
                              >
                                { props.t( "Month" ) }
                              </button>

                              <button
                                disabled={ coursesPeriod === "an" }
                                className="btn"
                                style={ {
                                  background: "#002437",
                                  color: "white",
                                } }
                                onClick={ ( e ) =>
                                {
                                  e.preventDefault();
                                  onChangeCoursesPeriod( "an" );
                                } }
                              >
                                { props.t( "Year" ) }
                              </button>
                            </div>
                            <FormGroup className="d-block d-md-none">
                              <Input
                                id="exampleSelect"
                                name="select"
                                type="select"
                                onChange={ ( e ) =>
                                  onChangeCoursesPeriod( e.target.value )
                                }
                              >
                                <option
                                  selected
                                  disabled={ coursesPeriod === "" }
                                  className="btn"
                                  style={ {
                                    background: "#002437",
                                    color: "white",
                                  } }
                                  value="tous"
                                >
                                  { props.t( "Tous" ) }
                                </option>

                                <option
                                  disabled={ coursesPeriod === "aujourd'hui" }
                                  className="btn"
                                  style={ {
                                    background: "#002437",
                                    color: "white",
                                  } }
                                  value="aujourd'hui"
                                >
                                  { props.t( "Today" ) }
                                </option>

                                <option
                                  disabled={ coursesPeriod === "semaine" }
                                  className="btn"
                                  style={ {
                                    background: "#002437",
                                    color: "white",
                                  } }
                                  value="semaine"
                                >
                                  { props.t( "Week" ) }
                                </option>

                                <option
                                  disabled={ coursesPeriod === "mois" }
                                  className="btn"
                                  style={ {
                                    background: "#002437",
                                    color: "white",
                                  } }
                                  value="mois"
                                >
                                  { props.t( "Month" ) }
                                </option>

                                <option
                                  disabled={ coursesPeriod === "an" }
                                  className="btn"
                                  style={ {
                                    background: "#002437",
                                    color: "white",
                                  } }
                                  value="an"
                                >
                                  { props.t( "Year" ) }
                                </option>
                              </Input>
                            </FormGroup>
                          </div>
                        </div>
                        <div className="flex-shrink-0 ms-auto mt-3">
                          <div className="justify-content-end gap-1">
                            <Input
                              readOnly={ coursesPeriodList.length < 0 }
                              type="text"
                              placeholder="Rechercher..."
                              value={ searchTerm }
                              onChange={ ( e ) => setSearchTerm( e.target.value ) }
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        { !loading ? (
                          coursesPeriodList && coursesPeriodList.length > 0 ? (
                            <div>
                              <Row className="mb-3 g-3 justify-content-end">
                                <Col sm="6" className="mb-3">
                                  <select
                                    id="custom-select"
                                    className="form-select"
                                    value={ optionFilterValue }
                                    onChange={ ( e ) =>
                                    {
                                      setOptionFilterValue(
                                        e.target.value || ""
                                      );
                                    } }
                                  >
                                    <option value="">Tous</option>
                                    { optionFilter.map( ( option, key ) => (
                                      <>
                                        <option key={ key } value={ option }>
                                          { option }
                                        </option>
                                      </>
                                    ) ) }
                                  </select>
                                </Col>
                              </Row>
                              <div className="profile-timeline">
                                <div className="accordion accordion-flush">
                                  { coursesPeriodList.map( ( course, key ) => (
                                    <div
                                      className="accordion-item border-0"
                                      key={ key }
                                      id={ `${ course.api_course_id }` }
                                    >
                                      <div
                                        className="accordion-header"
                                        id={ `heading${ key }` }
                                      >
                                        <Link
                                          to="#"
                                          className="accordion-button p-2 shadow-none"
                                        >
                                          <div className="d-flex">
                                            <div
                                              className="flex-shrink-0"
                                              style={ {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              } }
                                            >
                                              <i
                                                className={ `bx bx-${ course.engin_designation ===
                                                    "Moto"
                                                    ? "cycling"
                                                    : "car"
                                                  } avatar-xs rounded-circle` }
                                                style={ {
                                                  border: "1px solid #002437",
                                                  background: "white",
                                                  fontSize: "2rem",
                                                } }
                                              />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                              <Row className="w-100 fs-14 mb-1 d-flex justify-content-between">
                                                <Col xxl={ 9 }>
                                                  Course{ " " }
                                                  { course.engin_designation }{ " " }
                                                  { course?.engin_classe }
                                                </Col>
                                                <Col
                                                  xxl={ 3 }
                                                  className="justify-content-end"
                                                >
                                                  <span
                                                    className={ `badge bg-soft-${ statutColor(
                                                      course.course_status
                                                    ) } text-${ statutColor(
                                                      course.course_status
                                                    ) } align-middle` }
                                                  >
                                                    { course.course_status }
                                                  </span>
                                                </Col>
                                              </Row>
                                              <small className="text-muted">
                                                { course.adresse_depart } { " -- " }
                                                { course.adresse_destination }
                                              </small>
                                            </div>
                                          </div>
                                        </Link>
                                      </div>

                                      <UncontrolledCollapse
                                        className="accordion-collapse"
                                        toggler={ `#heading${ key }` }
                                        defaultOpen={ key === 0 }
                                      >
                                        <div className="accordion-body ms-2 ps-5">
                                          <ul className="list-unstyled text-muted vstack gap-3">
                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="bx bx-trip fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Date: </b>
                                                  { formatDate(
                                                    course.date_course
                                                  ) }
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="bx bx-trip fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Départ: </b>
                                                  { course.adresse_depart }
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="bx bx-trip fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Destination: </b>
                                                  { course.adresse_destination }
                                                </div>
                                              </div>
                                            </li>

                                            { course.numero_tel_course && (
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>
                                                      Contact sur la course:{ " " }
                                                    </b>
                                                    { course.numero_tel_course }
                                                  </div>
                                                </div>
                                              </li>
                                            ) }

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Type d'engin: </b>
                                                  {/* {course.type_engin_id} */ }
                                                  {
                                                    course.engin_designation
                                                  }{ " " }
                                                  { course?.engin_classe }
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Distance: </b>
                                                  { course.distance_estimee || 0 }
                                                  { " Km" }
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Coût estimé: </b>
                                                  { course.cout_estimee || 0 }
                                                  { " XOF" }
                                                </div>
                                              </div>
                                            </li>

                                            { course.cout_effectif && (
                                              <li>
                                                <div className="d-flex">
                                                  <div className="flex-shrink-0 text-secondary me-1">
                                                    <i className="ri-subtract-line fs-15 align-middle"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <b>Coût effectif: </b>
                                                    { course.cout_effectif || 0 }
                                                    { " XOF" }
                                                  </div>
                                                </div>
                                              </li>
                                            ) }

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Mode de paiement: </b>
                                                  { course.mode_payement }
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Client: </b>
                                                  <Link
                                                    to={ `client/${ course.client_id }` }
                                                  >
                                                    { course.first_name_client }{ " " }
                                                    { course.last_name_client }
                                                  </Link>
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="d-flex">
                                                <div className="flex-shrink-0 text-secondary me-1">
                                                  <i className="ri-subtract-line fs-15 align-middle"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                  <b>Conducteur: </b>
                                                  <Link
                                                    to={ `chauffeur/${ course.conducteur_id }` }
                                                  >
                                                    {
                                                      course.first_name_conducteur
                                                    }{ " " }
                                                    {
                                                      course.last_name_conducteur
                                                    }
                                                  </Link>
                                                </div>
                                              </div>
                                            </li>

                                            { course?.note !== null &&
                                              course?.note !== 0 && (
                                                <li>
                                                  <div className="flex-grow-1">
                                                    <i className="ri-subtract-line fs-15 align-middle text-secondary me-1"></i>
                                                    <b>Note: </b>
                                                    <Button
                                                      className="btn btn-dark text-white"
                                                      id={ `note-${ course.api_course_id }` }
                                                    >
                                                      note
                                                    </Button>
                                                    <UncontrolledTooltip
                                                      placement="top"
                                                      target={ `note-${ course.api_course_id }` }
                                                    // trigger="click"
                                                    >
                                                      { course.note + " / 5" }
                                                    </UncontrolledTooltip>
                                                  </div>
                                                </li>
                                              ) }

                                            { course.commentaire && (
                                              <li>
                                                <div className="flex-grow-1">
                                                  <i className="ri-subtract-line fs-15 align-middle text-secondary me-1"></i>
                                                  <b>Commentaire: </b>
                                                  <Button
                                                    id={ `commentaire-${ course.api_course_id }` }
                                                  >
                                                    commentaire
                                                  </Button>
                                                  <UncontrolledTooltip
                                                    placement="top"
                                                    target={ `commentaire-${ course.api_course_id }` }
                                                  // trigger="click"
                                                  >
                                                    { course.commentaire }
                                                  </UncontrolledTooltip>
                                                </div>
                                              </li>
                                            ) }
                                          </ul>
                                        </div>
                                      </UncontrolledCollapse>
                                    </div>
                                  ) ) }
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center my-3">
                              <h2>Pas de Courses</h2>
                            </div>
                          )
                        ) : (
                          <div className="text-center my-3">
                            <Loader style={ { color: "#014c94" } } />
                            <h2>Chargement...</h2>
                          </div>
                        ) }
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

HistoriqueCourses.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( HistoriqueCourses ) );
